
export const appTheme = {
  token: {
    colorPrimary: '#3d52a1',         // Base primary color
    colorPrimaryHover: '#7191e6',     // Brighter for hover state
    colorPrimaryActive: '#3a4a8c',    // Darker for active state
    colorPrimaryTextHover: '#2d3b73', // Darkest for text hover or selected state
    colorBorder: '#adbada',           // Soft border color
    colorText: '#222',
    colorPrimaryOutline: '#7191e6',
    colorLink: '#3d52a1',
    colorCheckboxBorder: '#8697c3',   // Border color for checkbox
    colorCheckboxChecked: '#3d52a1',  // Checked color (same as primary)
    colorCheckboxHover: '#7191e6',
    fontFamily: 'IBM Plex Sans, sans-serif',
    sizePopupArrow: 20,
  },

  components: {
    Button: {
      controlHeight: 40,
      borderRadius: 6
    },
    Checkbox: {
      controlHeight: 40,
      borderRadius: 6
    }
  }

};